import { BrandLogo } from '@/components/brand/BrandLogo';
import { nav, site, WHATSAPP_DISPLAY, whatsappLink } from '../site-config';

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-[#0e1a28] text-white">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-10 sm:grid-cols-3">
        <div>
          <BrandLogo variant="compactOnDark" className="h-8" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/65">
            Software sério para administrar uma oficina.
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold">Navegação</p>
          <ul className="mt-3">
            {nav.map((item) => (
              <li key={item.href}>
                <a href={item.href} className="inline-flex min-h-10 items-center text-sm text-white/70 hover:text-white">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-sm font-semibold">Contato</p>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex min-h-10 items-center text-sm text-white/70 hover:text-white"
          >
            {WHATSAPP_DISPLAY}
          </a>
          <a href={`mailto:${site.email}`} className="flex min-h-10 items-center text-sm text-white/70 hover:text-white">
            {site.email}
          </a>
        </div>
      </div>
      <p className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © {year} {site.name}. Todos os direitos reservados.
      </p>
    </footer>
  );
}
